<template>
  <ViewTransition>
    <div class="tienda">
      <CampaignHeader :title="title" />
      <div class="cont">
        <div class="contHeader">
          <h1>
            {{ text.titulo }}
            <span>{{ text.tituloDesk }}</span>
          </h1>
          <p>
            {{ text.subtitulo }}
          </p>
        </div>
        <div class="contImagenes">
          <a
            v-for="(value, index) in stores"
            :key="index"
            :href="value.link"
            target="_blank"
            @click="evib2cOutboundlink(value.alt, 'ecommerce')"
          >
            <img :src="value.src" :alt="value.alt" />
          </a>
        </div>
      </div>
      <p class="Products-excess">EVITE EL EXCESO</p>
    </div>
  </ViewTransition>
</template>
<script>
import ViewTransition from "@/transitions/ViewTransition.vue";
import CampaignHeader from "@/components/CampaignHeader";
import { stores, text } from "@/data/buy.js";
import TagFunctions from "@/assets/tagFunctions.js"

export default {
  name: "tienda",
  components: {
    ViewTransition,
    CampaignHeader,
  },
  data: () => ({
    stores,
    text,
    title: "DONDE COMPRAR",
  }),

  computed: {},
  methods: {
    evib2cOutboundlink(name, type){
      TagFunctions.evib2cOutboundlinkPush(name, type)
    }
  },
  mounted() {
    TagFunctions.evPagePush('Donde Comprar')
  },
};
</script>

<style lang="stylus" scoped>
@import './Buy.styl';
</style>
